
import React, { useRef, useState } from 'react';

import { getToken, local_utc_timestamp, utc_local } from '../../../helpers/Helper';
import { POST_PAYROLL_REPORTS } from '../../../helpers/url_helper';
import SimpleReactValidator from 'simple-react-validator';


import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PayrollSummary = () => {
    const { t } = useTranslation();

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [, forceUpdate] = useState();

    const [filter_option, setFilterOption] = useState({
        startDate: local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
        endDate: local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)),
        shortBy: 'name',
        offset: -new Date().getTimezoneOffset()
    });


    // input text change handler
    const dateChange = (date) => {
        // if (!date) return;

        // Start of month
        const startDate = new Date(date.getFullYear(), date.getMonth(), 1);

        // End of month
        const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        filter_option.startDate = local_utc_timestamp(new Date(startDate).getTime());
        filter_option.endDate = local_utc_timestamp(new Date(endDate).getTime());
        console.log(filter_option);
        setFilterOption({ ...filter_option })
    }

    
    // input text change handler
    const handleInputChangeFilter = (event) => {
        filter_option[event.target.name] = event.target.value;
        setFilterOption({ ...filter_option });
    }

    // form submit event
    const handleSubmit = async (type) => {
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            try {
                SetButtonDisabled(true);
                filter_option.type = type;
                const response = await fetch(`${POST_PAYROLL_REPORTS}`, {
                    method: "POST",
                    headers: {
                        Authorization: `${getToken()}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(filter_option),
                });
                if (response.ok) {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);

                    let extension = "xlsx"; // default
                
                    if (type === 'pdf') {
                        extension = "pdf";
                    }
                
                    // 👉 File name with correct extension
                    const fileName = `Payroll-Summary-Report-${utc_local(filter_option.startDate,'MMM-YYYY')}.${extension}`;
                    

                    // 👉 Create hidden download link
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    // Clean up blob
                    URL.revokeObjectURL(url);

                    // window.open(url, '_blank');
                }
                SetButtonDisabled(false);
            } catch (error) {
                toast.error(error.message);
                SetButtonDisabled(false);
            }
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>{t('reports.payrollSummaryReport.title')} </h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />

                            <div className='row mb-3'>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Select Date</label>
                                    <DatePicker
                                        name='startDate'
                                        className='form-control'
                                        selected={filter_option.startDate}
                                        onChange={dateChange}
                                        dateFormat="MM, yyyy"
                                        showMonthYearPicker
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Short By</label>
                                    <select name='shortBy' className='form-control' value={filter_option.shortBy} onChange={handleInputChangeFilter}>
                                        <option value="name">Name - ASC</option>
                                        <option value="employeeId">Employee Id - ASC</option>
                                        <option value="employeeCode">Employee Code - ASC</option>
                                    </select>
                                </div>
                                <div className='col-sm-6 mb-3 pt-4'>
                                    <button type='button' onClick={()=> {handleSubmit('pdf')}} disabled={ButtonDisabled} className='btn btn-primary me-3 mb-3'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Download PDF</button>
                                    <button type='button' onClick={()=> {handleSubmit('excel')}} disabled={ButtonDisabled} className='btn btn-primary me-3 mb-3'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Download Excel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default PayrollSummary;